import { styled } from "@mui/material";
import { DataGrid, GridColDef, GridRowsProp, DataGridProps } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../components/DataGridComponent/CustomNoRowsOverlay";
import DataGridLoading from "../../components/DataGridComponent/DataGridLoading";
import DataGridComponentBase, { DataGridComponentProps } from "../../components/DataGridComponent/DataGridComponent";

const StyledDataGrid = styled(DataGridComponentBase)(() => ({
"& .MuiDataGrid-main": {
    fontSize: "0.8rem",
    lineHeight: "1.2rem",
    },
    border: "solid 1px #eeeeee",
    "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#ece9fd",
    width: "100%",
    },
    "& .MuiDataGrid-columnHeader": {
    padding: 0,
    "&:focus": {
        outline: "transparent",
    },
    },

    "& .MuiDataGrid-columnHeaderTitleContainer": {
    justifyContent: "center",
    },

    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
    width: "100%",
    justifyContent: "center",
    textTransform: "uppercase",
    },
    "& .css-t89xny-MuiDataGrid-columnHeaderTitle": {
    fontWeight: "bold",
    },

    "& .MuiDataGrid-iconButtonContainer button": {
    padding: "4px",
    },

    "& .MuiDataGrid-columnSeparator": {
    display: "none",
    },
    "& .MuiDataGrid-cell": {
    justifyContent: "center",
    // minHeight: "45px !important",
    "&:focus": {
        outline: "transparent",
    },
    },
    "& .MuiDataGrid-withBorderColor": {
    borderColor: "transparent",
    },
    "& .MuiDataGrid-row:nth-child(odd):hover, & .MuiDataGrid-row:nth-child(odd)":
    {
        backgroundColor: "transparent",
    },
    "& .MuiDataGrid-row:nth-child(even):hover, .MuiDataGrid-row:nth-child(even)":
    {
        backgroundColor: "#f6f6f6",
    },
}));

const DataGridComponent = (props: DataGridComponentProps) => {
  return (
    <StyledDataGrid
        getRowHeight={() => 40}
        // getEstimatedRowHeight={() => 200}
        // rowHeight={50}
        columnHeaderHeight={30}
        {...props}
        className="StyledDataGrid"
      />
  );
};

export default DataGridComponent;
